/* ARRAY - PHONE CAROUSEL. One draggable row below 750px; normal grid above.

   WHY. Stacked 2-up grids made the phone homepage very tall. A row of cards is
   about half the height and reads as something to swipe.

   NO SCROLL SNAP - AND THAT IS THE POINT. v1 used scroll-snap-type:x mandatory
   and the client's verdict was "not smooth, it snappy... snapping one for
   another product". Snap also broke the arrows: with snap ON a smooth scrollTo
   does nothing at all, with snap OFF a hand-animated scrollLeft is reverted
   every frame, and restoring snap a moment early yanks the row back - which is
   why the arrows only worked on every second press. Dropping snap removes all
   of it. The row free-scrolls, the finger gets real momentum, and scrollTo
   smooth just works. DO NOT REINTRODUCE scroll-snap-type here.

   MOMENTUM is velocity measured over the last pointer move, then decayed 6% a
   frame. Phones give this for free; a mouse drag does not, and without it a
   desktop drag stops dead and feels broken.

   TARGETS ARE SELECTORS - no section file is edited, which matters because
   these sections are large and their class names are used elsewhere. Add a line
   to carousel another one. Best Sellers WAS in this list and was taken out at
   the client's request ("make the best seller section as it was"); if it ever
   comes back, note it holds 8 products behind a 4-card pager, `.gt-nav`, which
   would need hiding or it shows two sets of arrows.

   A DRAG MUST NOT OPEN A PRODUCT - the cards are anchors, so movement past
   DRAG_SLOP arms a one-shot capture-phase click swallower.

   AUTO-ADVANCE every 3s, the interval the client asked for; pauses while a
   finger is down and for 5s after. No hover pause - no hover on these devices.
*/
(function () {
  'use strict';

  var MQ = '(max-width: 749px)';
  var INTERVAL = 3000;
  var RESUME = 5000;
  var DRAG_SLOP = 6;
  var FRICTION = 0.94;

  var TARGETS = [
    { row: '.beyondads-edit .dh-row', mount: '.beyondads-edit .dh-in' },
    { row: '.beyondads-babycare .bz-cradle', mount: '.beyondads-babycare .bz-in' }
  ];

  var AL = '<svg viewBox="0 0 26 9" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M26 4.5H2M5.5 1.2 2 4.5l3.5 3.3"/></svg>';
  var AR = '<svg viewBox="0 0 26 9" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M0 4.5h24M20.5 1.2 24 4.5l-3.5 3.3"/></svg>';

  var instances = [];

  function slides(row) {
    var out = [];
    for (var i = 0; i < row.children.length; i++) {
      var el = row.children[i];
      if (el.nodeType !== 1) continue;
      if (getComputedStyle(el).display === 'none') continue;
      out.push(el);
    }
    return out;
  }

  function make(cfg) {
    var row = document.querySelector(cfg.row);
    var mount = document.querySelector(cfg.mount);
    if (!row || !mount) return null;

    var nav = document.createElement('div');
    nav.className = 'bdc-nav';
    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = next.className = 'bdc-btn';
    prev.setAttribute('aria-label', 'Previous');
    next.setAttribute('aria-label', 'Next');
    prev.innerHTML = AL;
    next.innerHTML = AR;
    nav.appendChild(prev);
    nav.appendChild(next);

    var timer = null, hold = null, glideToken = 0;
    var live = false;

    function centreOf(el) {
      var r = el.getBoundingClientRect(), rr = row.getBoundingClientRect();
      return row.scrollLeft + (r.left - rr.left) - (row.clientWidth - el.offsetWidth) / 2;
    }

    function nearest() {
      var s = slides(row), best = 0, bd = Infinity;
      for (var i = 0; i < s.length; i++) {
        var d = Math.abs(centreOf(s[i]) - row.scrollLeft);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }

    function glide(to) {
      glideToken++;
      var max = row.scrollWidth - row.clientWidth;
      var x = Math.max(0, Math.min(to, max));
      if (row.scrollTo) {
        try { row.scrollTo({ left: x, behavior: 'smooth' }); return; } catch (e) {}
      }
      row.scrollLeft = x;
    }

    function go(dir) {
      var s = slides(row);
      if (!s.length) return;
      var i = nearest() + dir;
      if (i >= s.length) i = 0;
      if (i < 0) i = s.length - 1;
      glide(centreOf(s[i]));
    }

    function start() { stop(); timer = setInterval(function () { go(1); }, INTERVAL); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function defer() { stop(); clearTimeout(hold); hold = setTimeout(start, RESUME); }

    prev.addEventListener('click', function () { go(-1); defer(); });
    next.addEventListener('click', function () { go(1); defer(); });

    var down = false, sx = 0, sl = 0, moved = 0, vel = 0, lx = 0, lt = 0;

    function coast() {
      var mine = ++glideToken;
      (function f() {
        if (mine !== glideToken || down) return;
        row.scrollLeft += vel;
        vel *= FRICTION;
        if (Math.abs(vel) > 0.25) requestAnimationFrame(f);
      })();
    }

    function onDown(e) {
      if (!live || e.button > 0) return;
      glideToken++;
      down = true; moved = 0; vel = 0;
      sx = lx = e.clientX; sl = row.scrollLeft; lt = performance.now();
      row.classList.add('bdc-drag');
      stop();
    }
    function onMove(e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      var now = performance.now(), dt = now - lt;
      if (dt > 0) vel = ((lx - e.clientX) / dt) * 16;
      lx = e.clientX; lt = now;
      row.scrollLeft = sl - dx;
      if (e.cancelable) e.preventDefault();
    }
    function onUp() {
      if (!down) return;
      down = false;
      row.classList.remove('bdc-drag');
      if (moved > DRAG_SLOP) {
        row.__swallow = true;
        setTimeout(function () { row.__swallow = false; }, 60);
        if (Math.abs(vel) > 0.5) coast();
      }
      defer();
    }

    row.addEventListener('pointerdown', onDown);
    row.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    row.addEventListener('click', function (e) {
      if (row.__swallow) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    row.addEventListener('touchstart', function () { stop(); }, { passive: true });
    row.addEventListener('touchend', function () { defer(); }, { passive: true });

    return {
      on: function () {
        if (live) return;
        live = true;
        row.classList.add('bdc-row');
        if (nav.parentNode !== mount) mount.appendChild(nav);
        row.scrollLeft = 0;
        start();
      },
      off: function () {
        if (!live) return;
        live = false;
        stop();
        clearTimeout(hold);
        glideToken++;
        row.classList.remove('bdc-row', 'bdc-drag');
        row.scrollLeft = 0;
        if (nav.parentNode) nav.parentNode.removeChild(nav);
      }
    };
  }

  function sync() {
    var small = window.matchMedia(MQ).matches;
    for (var i = 0; i < instances.length; i++) {
      if (small) instances[i].on(); else instances[i].off();
    }
  }

  function boot() {
    if (instances.length) { sync(); return; }
    for (var i = 0; i < TARGETS.length; i++) {
      var inst = make(TARGETS[i]);
      if (inst) instances.push(inst);
    }
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  window.addEventListener('load', boot);
  window.addEventListener('resize', sync);
  document.addEventListener('shopify:section:load', function () { instances.length = 0; boot(); });
})();
